var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Filter } from "./Filter";
import { Pager } from "./Pager";
export class SearchRequest {
  constructor(_data) {
    /**
     */
    __publicField(this, "Filter");
    /**
     */
    __publicField(this, "Pager");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchRequest
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.SearchSku.SearchRequest");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Filter"]) {
        const filter_ = new Filter();
        this.Filter = filter_.init(_data["Filter"]);
      }
      if (_data["Pager"]) {
        const pager_ = new Pager();
        this.Pager = pager_.init(_data["Pager"]);
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Filter"] = this.Filter ? this.Filter.toJSON() : void 0;
    _data["Pager"] = this.Pager ? this.Pager.toJSON() : void 0;
    return _data;
  }
}
